<template>
  <div class="stores">
    <div class="breadcrumb">训练营 > 训练营报名</div>
    <div class="searchBtn">
      <div class="search_item">
        <div>手机号</div>
        <input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile" @keyup.enter="search_mine()"/>
      </div>
      <el-button type="primary" @click="search_mine()">搜索</el-button>
      <el-button size='small' type="primary" @click="editGroup" plain>分组</el-button>
    </div>
    <div class="main">
      <template>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="学员号"></el-table-column>
          <el-table-column prop="nickname" label="呢称"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <!--<el-table-column prop="courseName" label="课程名称"></el-table-column>
          <el-table-column prop="null" label="运动时间（分钟）"></el-table-column>
          <el-table-column prop="null" label="运动时间（分钟）"></el-table-column>-->
          <el-table-column prop="age" label="年龄"></el-table-column>
          <el-table-column prop="height" label="身高"></el-table-column>
          <el-table-column prop="weight" label="体重"></el-table-column>
          <el-table-column prop="groupName" label="组别"></el-table-column>
        </el-table>
      </template>
      <div class="block" style="padding:30px 10px; float:right">
        <el-pagination
          @current-change="handleCurrentChangePage"
          :current-page="pageNum"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="请选择分组" :visible.sync="dialogVisible" width="300px" :before-close="handleClose">
      <el-form status-icon label-width="80px">
        <!--<el-form-item label="名称" prop="name">
          <el-input placeholder="请输入名称" style="width:80%"></el-input>
        </el-form-item>-->
        <el-form-item label="组别" prop="groupId">
          <input type="hidden"/>
          <el-select v-model="groupId" placeholder="请选择组别" style="width: 80%;" @change="rulegroup">
            <el-option v-for="gitem in groupList" :key="gitem.id" :label="gitem.groupName"
                       :value="gitem.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="updataGroup()">确 定</el-button>
	      	</span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    components: {},
    mounted() {
      this.init();
    },
    data() {
      return {
        headers: {
          xqiao_token: localStorage.getItem("token")
        },
        courseName: '',
        mobile: '',
        userName: '',
        tableData: [],
        pageNum: 1,
        limit: 10,
        totalPage: 10,
        multipleSelection: [],
        dialogVisible: false,
        groupList: [],
        groupId: null
      };
    },
    methods: {
      //初始化表格数据
      init() {
        var params = {
          pageNum: this.pageNum,
          limit: this.limit,
          // courseName: this.courseName,
           mobile: this.mobile,
          // userName: this.userName
        };
        this.$get("/offlineTrainingCamp/user/list", params)///trainingCamp/getList
          .then(res => {
            if (res.code == 0) {
              this.tableData = res.data.list;
              this.totalPage = res.data.total;
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
              return false;
            }
          })
          .catch(() => {
            console.log();
          });
      },
      //当前页数
      handleCurrentChangePage(val) {
        this.pageNum = val;
        this.init();
      },
      search_mine() {
        this.init();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      //弹框关闭按钮
      handleClose(done) {
        if (this.$refs.ruleForm != undefined) {
          this.$refs.ruleForm.resetFields();
        }
        done();
      },
      editGroup() {
        var currentRowIds = this.multipleSelection;
        console.log(currentRowIds);
        if (currentRowIds.length > 0) {
          this.dialogVisible = true;
          this.$get("/offlineTrainingCamp/group/list")//获取所有组名"
            .then(res => {
              if (res.code == 0) {
                this.groupList = res.data;
              }
            })
            .catch(() => {
            });
        } else {
          this.dialogVisible = false;
          this.$message({
            message: "请选择信息",
            type: "warning"
          });
          return false;
        }
      },
      rulegroup(val) {
        console.log("cons", val);
        this.groupId = val
      },
      updataGroup() {
        let dataFer = {"groupId": this.groupId, "offlineTrainingCampUserIdList": []};
        var currentRowIds = this.multipleSelection;
        for (var i = 0; i < currentRowIds.length; i++) {
          dataFer.offlineTrainingCampUserIdList.push(currentRowIds[i].id);
        }
        this.$post("offlineTrainingCamp/user/grouping", JSON.stringify(dataFer))//批量分组
          .then(res => {
            if (res.code == 0) {
              this.groupId = null;
              this.dialogVisible = false;
              this.init();
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
              return false;
            }
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style scoped>
  .searchBtn{
    display:flex
  }

  .search_item{
    display:flex;
    font-size:13px;
    align-items:center;
    margin-right:20px
  }

  .search_item div{
    margin-right:10px;
  }

  .search_item input{
    flex:1
  }

</style>



// WEBPACK FOOTER //
// src/views/trainingCamp/campApply.vue